import React, { Suspense } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { useStore } from './store/Store';
import { observer } from 'mobx-react';
import { lazyWithRetries } from './utils/lazyWithRetries';
import Support from './pages/Support/Support';
import QrList from './pages/QrList/QrList';

const Nets = lazyWithRetries(() => import('./plugins/nets/Nets'));
const Stripe = lazyWithRetries(() => import('./plugins/stripe/Stripe'));
const MatchMaking = React.lazy(() => import('./pages/Matchmaking/Matchmaking'));
const LeaderBoard = React.lazy(() => import('./pages/LeaderBoard/LeaderBoard'));
const CheckIn = React.lazy(() => import('./pages/Checkin/Checkin'));

const basename = !window.location.hostname.includes('localhost') ? '/cview' : '';

const App = () => {

  //comment test
  const store = useStore();
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/cms/web/:id" element={<Layout key="cms-web" {...store} />} />
        <Route path="/web/:id" element={<Layout key="web" {...store} />} />

        <Route
          path="/web/card/:id"
          element={
            <Suspense fallback={<div />}>
              <Nets />
            </Suspense>
          }
        />

        <Route
          path="/web/stripe/:id"
          element={
            <Suspense fallback={<div />}>
              <Stripe />
            </Suspense>
          }
        />


        <Route path="/support-test" element={<Support />} />

        <Route path="/checkin/:id" element={<CheckIn />} />
        <Route path="/qr-list/:id" element={<QrList />} />

        <Route
          path="/leaderboard/:id"
          element={
            <Suspense fallback={<div />}>
              <LeaderBoard />
            </Suspense>
          }
        />

        <Route path="/matchmaking" element={<MatchMaking />} />

        <Route path="/" element={<div className="text-center">No route was found</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default observer(App);
